<span><span *ngIf="rowOnEdit" class="row-edited">{{user_name}}</span>{{value}}</span>
<span *ngIf="delete" class="status-badge__delete"><mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="delete"></mat-icon></span>
